import { Box, Divider, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { ChangelogWidget } from "@/features/changelog/ChangelogWidget";

import { ApiDocsButton } from "./components/ApiDocsButton/ApiDocsButton";
import { AppWarnings } from "./components/AppWarnings/AppWarnings";
import { HelpCenterButton } from "./components/HelpCenterButton/HelpCenterButton";
import { IntercomButton } from "./components/IntercomButton/IntercomButton";
import { NextAppButton } from "./components/NextAppButton/NextAppButton";

const StickyFooterContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  justifyContent: "flex-end",
  position: "sticky",
  bottom: 0,
  backgroundColor: theme.palette.secondary[9],
}));

export const PrimaryNavigationFooter = () => (
  <StickyFooterContainer>
    <Stack spacing={1} data-product-tour="primary-navigation-footer">
      <AppWarnings />
      <ChangelogWidget />
      <Box
        sx={{
          px: 3,
          py: 1,
        }}
      >
        <Divider sx={{ borderColor: "secondary.6" }} />
      </Box>
      <NextAppButton />
      <IntercomButton />
      <ApiDocsButton />
      <HelpCenterButton />
    </Stack>
  </StickyFooterContainer>
);
